import { useSearchParams } from 'react-router-dom'

import { Button, IconArrowInbox } from '@sequencehq/core-components'
import { useBillingSchedulesCsvExport } from 'modules/BillingSchedules/hooks/useBillingSchedulesCsvExport'

export const BillingSchedulesExportToCsv = () => {
  const [searchParams] = useSearchParams()

  const { download } = useBillingSchedulesCsvExport()

  const buttonProps = {
    variant: 'secondary',
    leadingIcon: <IconArrowInbox color="initial" />,
    'data-testid': 'billingSchedules.exportToCsv'
  } as const

  if (!download.available) {
    return null
  }

  return (
    <Button {...buttonProps} onClick={() => download.onClick(searchParams)}>
      Export to CSV
    </Button>
  )
}
